export default __webpack_public_path__ + "static/media/hero_bg.a91c7fd7.jpg";